import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  TemplateRef,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { HumanizePipe } from '@app/core/pipes/humanize.pipe';
import { ClickedOutsideDirective } from '../../directives/clicked-outside.directive';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgTemplateOutlet } from '@angular/common';
import { Ag1LoaderComponent } from '../ag1-loader/ag1-loader.component';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

export interface SearchEvent {
  searchTerm: string;
  searchField: string;
}

export interface ISeachField {
  name: string;
  displayName?: string;
}
@Component({
  selector: 'ag1-search',
  templateUrl: './ag1-search.component.html',
  providers: [HumanizePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ClickedOutsideDirective,
    FormsModule,
    AngularSvgIconModule,
    NgTemplateOutlet,
    Ag1LoaderComponent,
    HumanizePipe,
    SentenceCasePipe,
  ],
})
export class Ag1SearchComponent implements OnChanges {
  // (optional) allow users to search by specific fields
  // if not provided, search will be done on all fields
  // ui will not show field dropdown if not provided
  @Input()
  searchFields: string[] | ISeachField[] = [];
  @Input()
  placeholder = '';
  @Input()
  disabled: boolean;
  @Input()
  btnVariant: 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger' =
    'primary';
  @Input()
  showResults: boolean = false;
  @Input()
  isLoading: boolean = false;
  @Input()
  searchField: string = 'all';
  @Input()
  showAllFieldsOption = true;

  // passed in results template
  @ContentChild('customResults', { static: false })
  customResultsRef?: TemplateRef<any>;

  @Output()
  searchEvent = new EventEmitter<SearchEvent>();
  @Input()
  searchTerm: string = '';

  showResultsTemplate: boolean = false;
  hasSearchFields: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchFields) {
      this.hasSearchFields = this.searchFields?.length > 0;
    }
  }

  isSimpleType(field: string | ISeachField): boolean {
    return typeof field === 'string';
  }

  hasDisplayName(field: string | ISeachField): boolean {
    if (this.isSimpleType(field)) {
      return false;
    }

    return (field as ISeachField).displayName !== undefined;
  }

  onFieldChangeEvent(event): void {
    // run search on field change
    if (!this.searchTerm) {
      this.showResultsTemplate = false;
      return;
    }

    this.searchField = event;
    this.runSearch();
  }

  onEnterPressEvent(event: KeyboardEvent): void {
    // run search on enter key press
    if (event.key !== 'Enter') {
      return;
    }

    this.runSearch();
  }

  onModelChangeEvent(): void {
    // run search when clicking the clear button
    if (this.searchTerm !== '') {
      return;
    }

    this.runSearch();
  }

  onSearchButtonEvent(): void {
    // run search on button click
    this.runSearch();
  }

  runSearch(): void {
    this.searchEvent.emit({
      searchField: this.searchField,
      searchTerm: this.searchTerm.trim(),
    });
    this.showResultsTemplate = true;
  }
}
